var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bbbcbf",
    d: "M96.908 3.333l93.014 93.069-93.014 93.022L3.894 96.355 96.908 3.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.49 49.746h93.092v93.092H50.49L29.903 98.404 50.49 49.746z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.444 92.445v13.795h23.733l.757-.139c-.795 11.656-10.087 20.639-24.752 20.639-21.181 0-30.694-16.662-30.694-30.521 0-16.383 11.938-30.715 29.945-30.715 12.012 0 21.139 6.491 26.393 15.666l.48-.201L104.31 69.89s.127-.357-.018-.533C92.758 55.227 79.705 49.971 64.9 49.971c-7.72 0-17.556-1.025-23.173 1.85-14.339 7.337-38.892 25.975-38.892 44.8 0 16.473 19.698 34.219 31.694 42.512 6.465 4.471 21.721 3.715 31.112 3.715 20.733 0 44.627-13.633 44.627-46.152l-.139-3.974-.447-.276H67.444v-.001zM124.227 49.746h19.355v93.092h-19.355V49.746z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGLogo);
export default __webpack_public_path__ + "static/media/g-logo.d77e1d80dfd76519c53a752f089ba74b.svg";
export { ForwardRef as ReactComponent };